export default __webpack_public_path__ + "static/media/banner-seguro-saude-empresarial-mobile.6936a9da.png";